import type { Field } from 'payload'

export type WithBlockHtmlId = {
  htmlId?: string | null
}

export const blockHtmlIdField: Field = {
  name: 'htmlId',
  label: 'HTML ID',
  type: 'text',
  admin: {
    description: 'Optional ID rendered on the block for anchor links. Use a unique value without spaces.',
  },
}

export function getBlockHtmlId(block?: unknown) {
  if (!block || typeof block !== 'object') return undefined

  const htmlId = (block as WithBlockHtmlId).htmlId
  if (typeof htmlId !== 'string') return undefined

  const trimmedHtmlId = htmlId.trim()
  return trimmedHtmlId || undefined
}
